module.exports = __webpack_public_path__ + "static/media/pension-sme.5e4cfaf5.svg";